import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class CustomerBalance {
  async fetch(page, perPage) {
    const response = await ajaxService.get(`/users-balances?page=${page}&perPage=${perPage}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const customerBalanceService = new CustomerBalance();
export default customerBalanceService;
